// eslint-disable-next-line react-hooks/exhaustive-deps
import React, { useEffect, useState } from "react";
import MPaper from "Utils/Helpers/MPaper";
import AddCharactersData from "./components/Add";
import { Grid2 } from "@mui/material";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { setCharacterData } from "../../../../Redux/slices/mngrSlice";
import { useDispatch, useSelector } from "react-redux";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import TableCharactersData from "./components/Table";
import { get_characters } from "http/components/Characters";
import ManagePageDescription from "./components/PageDescription";

export default function CharactersData() {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [page, setPage] = useState(1);
  const { character } = useSelector((state) => ({
    character: state.mngr.character,
  }));

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (character || (data && data.paginattion.page !== page)) getData();
  }, [character, page]);

  const getData = async () => {
    dispatch(HandleLoading(true));
    const response = await get_characters(page);
    if (CheckApiStatus(response)) {
      setData(response.data);
    }
    dispatch(setCharacterData(false));
    dispatch(HandleLoading(false));
  };

  const onChangePage = (new_page) => {
    setPage(new_page);
  };

  return (
    <Grid2 container spacing={2}>
      <Grid2 item size={{ xs: 12 }}>
        <MPaper
          label={"Page Description"}
          content={<ManagePageDescription />}
        />
      </Grid2>
      <Grid2 item size={{ xs: 12 }}>
        <MPaper label={"New Character"} content={<AddCharactersData />} />
      </Grid2>
      <Grid2 item size={{ xs: 12 }}>
        <MPaper
          label={"Creatures list"}
          content={
            data && (
              <TableCharactersData data={data} onChangePage={onChangePage} />
            )
          }
          defaultExpanded={true}
        />
      </Grid2>
    </Grid2>
  );
}
